import { render, staticRenderFns } from "./UploadPictureModal.vue?vue&type=template&id=654bdf86&"
import script from "./UploadPictureModal.vue?vue&type=script&lang=js&"
export * from "./UploadPictureModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports